export default __webpack_public_path__ + "static/2-7edbbf4e97b4ad139bda4226c66c00f6.jpeg";